// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"675":"component---src-pages-menu-js","986":"component---src-templates-content-page-js"}[chunkId] + "-" + {"675":"d06ca95407a026407f4a","986":"1e797375d2b6a2afa28f"}[chunkId] + ".js";
};